import moment from 'moment';

// Saturdays that can be booked as an exception, only for the listed workshops (externalId).
// The day is still only selectable for technicians whose SAP working schedule includes it.
// Sundays are not supported: the calendar always hides that column.
export const enabledWeekendDates = [
  { date: '2026-11-07', workshops: ['TALLER_TE01_01'] },
  { date: '2026-11-28', workshops: ['TALLER_TE01_01'] },
];

export const isEnabledWeekendDate = (date, workshopExternalId) => {
  if (!workshopExternalId) return false;

  const day = moment(date).format('YYYY-MM-DD');

  return enabledWeekendDates.some(
    (item) => item.date === day && item.workshops.includes(workshopExternalId),
  );
};

// The month view also renders the trailing and leading days of the adjacent months (weeks start on Monday).
export const hasEnabledSaturdayInView = (month, workshopExternalId) => {
  if (!workshopExternalId) return false;

  const firstVisibleDay = moment(month).startOf('month').startOf('isoWeek');
  const lastVisibleDay = moment(month).endOf('month').endOf('isoWeek');

  return enabledWeekendDates.some(
    (item) =>
      item.workshops.includes(workshopExternalId) &&
      moment(item.date).isoWeekday() === 6 &&
      moment(item.date).isBetween(firstVisibleDay, lastVisibleDay, 'day', '[]'),
  );
};
